module.exports = __webpack_public_path__ + "01_face.5506103d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/01_face.png
// module id = ZSge
// module chunks = 0